import { createRootRoute, Outlet } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <div className="shell">
      <p className="shell__hint">Page not found.</p>
    </div>
  ),
});
